/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, Box, TextField } from '@mui/material';
import InputGroupV2 from '../InputGroupV2';

const getOptionLabel = (option) => {
  if (option == null) return '';
  if (typeof option === 'string') return option;
  return option.label != null ? String(option.label) : '';
};

const isOptionEqualToValue = (a, b) => {
  if (a == null || b == null) return false;
  if (a.value !== undefined && b.value !== undefined) {
    return a.value === b.value;
  }
  return a === b;
};

const MultiSelectV2 = ({
  label,
  onChange,
  placement,
  title,
  useTooltip,
  isRequired,
  options,
  defaultValue,
  error,
  helperText,
  disabled,
}) => {
  const value = Array.isArray(defaultValue) ? defaultValue : [];

  const handleChange = (event, newValue) => {
    if (newValue == null || (Array.isArray(newValue) && newValue.length === 0)) {
      onChange(null);
    } else {
      onChange(newValue);
    }
  };

  return (
    <InputGroupV2
      label={label}
      placement={placement}
      title={title}
      useTooltip={useTooltip}
      isRequired={isRequired}
    >
      <Autocomplete
        clearOnEscape
        disableCloseOnSelect
        disabled={disabled}
        filterSelectedOptions={false}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isOptionEqualToValue}
        multiple
        noOptionsText="Sem opções"
        options={options || []}
        value={value}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            fullWidth
            margin="dense"
            placeholder="Selecione..."
            variant="outlined"
            sx={{
              '& .MuiInputBase-root': {
                bgcolor: disabled ? 'transparent' : 'background.paper',
                minHeight: 38,
              },
            }}
          />
        )}
        slotProps={{
          listbox: {
            sx: { maxHeight: 200, overflow: 'auto' },
          },
          popper: {
            sx: (theme) => ({
              zIndex: theme.zIndex.modal + 1,
            }),
          },
        }}
      />
      {error ? (
        helperText ? (
          helperText
        ) : (
          <Box
            component="p"
            sx={{
              color: 'error.main',
              mt: 1,
              mx: 1.5,
              fontSize: 11,
              minHeight: '1em',
              textAlign: 'left',
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
              fontWeight: 400,
              lineHeight: 1,
              letterSpacing: '0.33px',
              m: 0,
            }}
          >
            O Campo é obrigatório
          </Box>
        )
      ) : null}
    </InputGroupV2>
  );
};

MultiSelectV2.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  defaultValue: PropTypes.array.isRequired,
  placement: PropTypes.string,
  title: PropTypes.string,
  useTooltip: PropTypes.bool,
  isRequired: PropTypes.any,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
};

MultiSelectV2.defaultProps = {
  placement: '',
  title: '',
  useTooltip: false,
  isRequired: false,
  error: false,
  helperText: null,
  disabled: false,
};

export default MultiSelectV2;
